// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AmaE","badges":"styles_badges__3v8R8"};